import requestApi from '@/utils/requestApi';

async function load() {
  var videoID = process.env.VUE_APP_VIDEO_ID;
  try {
    const response = await requestApi({
      url: `/v2/videos/${videoID}/videobot_content`,
      method: 'get',
    });
    var videobotContent = populateVideobotContent(response.data);
    this.videobotContent = videobotContent;
    return response.data;
  } catch (error) {
    console.warn(error);
  }
}

function populateCustomFields(text) {
  var view = window.ovmConfig.env;
  var output = window.Mustache.render(text, view);

  return output;
}

function populateVideobotContent(content) {
  for (var key in content) {
    if (typeof content[key] === 'object') {
      populateVideobotContent(content[key]);
    } else {
      content[key] = populateCustomFields(content[key]);
    }
  }
  return content;
}

function controlContent(content, profileName) {
  switch(profileName) {
    case "gestante":
      // delete content.licensa_maternidade.adocao
      delete content.cartilha_adocao
      delete content.cuidados_com_voce_pais
      break;
    case "fui_gestante":
      delete content.programas_bem_estar.acupuntura
      delete content.programas_bem_estar.fisioterapia_presencial_telereabilitacao
      // delete content.licensa_maternidade.adocao
      delete content.cartilha_adocao
      delete content.cuidados_com_voce_pais


      break;
    case "parceria":
      delete content.programas_bem_estar.nutricao
      delete content.programas_bem_estar.acupuntura
      delete content.programas_bem_estar.fisioterapia_presencial_telereabilitacao
      // delete content.licensa_maternidade.adocao
      delete content.cartilha_adocao


      break;
    case "parceira_e_bebe_nasceu":
      delete content.programas_bem_estar.nutricao
      delete content.programas_bem_estar.acupuntura
      delete content.programas_bem_estar.fisioterapia_presencial_telereabilitacao
      // delete content.licensa_maternidade.adocao
      delete content.cartilha_adocao


      break;
    case "processo_adotivo":
      delete content.beneficios.coparticipacao
      delete content.programas_bem_estar.nutricao
      delete content.programas_bem_estar.acupuntura
      //delete content.licensa_maternidade.parto
      delete content.cuidados_com_o_bebe.pega_correta_isso_existe
      delete content.cuidados_com_o_bebe.continuidade_do_aleitamento_e_ordenha_do_leite_materno
      break;
  }
}

export const actions = {
  load,
  controlContent
};
